module.exports = __webpack_public_path__ + "static/media/camera_gray.f88b5a6a.svg";